import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { ocScrollbarStyles } from '../../styles/OcScrollbar.styled';

/**
 * OC-specific wrapper - provides rounded borders and shadow
 */
export const OcChatWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.44);
  display: flex;
  flex-direction: column;
`;

/**
 * Content area with SVG background (transcript + input + footer)
 * Header sits above this without the SVG
 */
export const OcChatContent = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const OcHeaderWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.chatBorder};
  background-color: ${({ theme }) => (theme as IOcAppTheme).color.headerBg};
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 6px;
  padding-bottom: 6px;
`;

/**
 * Input wrapper for initial state - centered with background and border
 */
export const OcMessageInputWrapperInitial = styled.div`
  background-color: ${({ theme }) => theme.color.chatBg};
  margin-left: 1em;
  margin-right: 1em;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.color.chatBorder};
  width: 100%;
  max-width: 43em;
`;

/**
 * Input wrapper for active state - no background/border, with footer layout
 */
export const OcMessageInputWrapperActive = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-left: 1em;
  margin-right: 1em;
`;

/**
 * OC-specific chat layout that overrides the default ChatLayout
 * to support conditional centering in initial state
 */
export const OcChatLayout = styled.div<{ $isInitialState?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  ${({ $isInitialState }) => $isInitialState && 'align-items: center;'}
  ${({ $isInitialState }) => !$isInitialState && `
    flex: 1 1 auto;
    min-height: 0;
  `}
`;

/**
 * OC-specific transcript wrapper with custom scrollbar styling
 * Wraps the Transcript component to add OC-specific scrollbar appearance
 * Uses shared ocScrollbarStyles from OcScrollbar.styled.tsx
 */
export const OcTranscriptWrapper = styled.div<{ $isInitialState?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ $isInitialState }) => !$isInitialState && `
    flex: 1 1 auto;
    min-height: 0;
  `}

  /* Apply shared OC scrollbar styling to all descendants */
  & * {
    ${ocScrollbarStyles}
  }
`;
